/* Copyright (c) 2022-2026 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Button, theme } from "@nordcloud/gnui";

type Props = {
  onClose: () => void;
  onSave?: () => void;
};

export function EditButtons({ onClose, onSave }: Props) {
  return (
    <>
      <Button
        ml={theme.spacing.spacing02}
        icon="save"
        size="md"
        severity="low"
        aria-label="submit button"
        onClick={() => {
          onSave?.();
        }}
      />
      <Button
        ml={theme.spacing.spacing01}
        icon="close"
        size="md"
        severity="low"
        onClick={onClose}
        aria-label="cancel button"
      />
    </>
  );
}
